<template>
    <div
        :class="[colorClasses, sizeClasses]"
        class="font-medium rounded-lg inline-flex"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">
    import { computed, type PropType } from 'vue'

    const props = defineProps({
        color: {
            type: String as PropType<
                | 'warning'
                | 'warning-ghost'
                | 'secondary'
                | 'secondary-ghost'
                | 'info'
                | 'info-ghost'
                | 'success'
                | 'success-ghost'
                | 'danger'
                | 'danger-ghost'
            >,
            required: true,
        },
        size: {
            type: String as PropType<'small' | 'medium'>,
            default: 'small',
        },
    })

    const colorClasses = computed(() => {
        if (props.color === 'warning') {
            return 'bg-yellow-400 text-black'
        }

        if (props.color === 'warning-ghost') {
            return 'bg-yellow-50 text-yellow-900'
        }

        if (props.color === 'secondary') {
            return 'bg-gray-500 text-white'
        }

        if (props.color === 'secondary-ghost') {
            return 'bg-gray-100 text-gray-700'
        }

        if (props.color === 'info') {
            return 'bg-blue-500 text-white'
        }

        if (props.color === 'info-ghost') {
            return 'bg-blue-50 text-blue-600'
        }

        if (props.color === 'success') {
            return 'bg-active text-white'
        }

        if (props.color === 'success-ghost') {
            return 'bg-green-50 text-green-900'
        }

        if (props.color === 'danger') {
            return 'bg-error text-white'
        }

        if (props.color === 'danger-ghost') {
            return 'bg-red-50 text-red-900'
        }
    })

    const sizeClasses = computed(() => {
        if (props.size === 'medium') {
            return 'text-sm px-3 py-1'
        }

        return 'text-xs px-2 py-0.5'
    })
</script>
